import { styled } from "styled-components";
import { FaMoon, FaSignOutAlt } from "react-icons/fa";

import { ReactComponent as FaCirclePlay } from "../../assets/icons/play.svg";
import { ReactComponent as FaCirclePause } from "../../assets/icons/pause.svg";
import { Skeleton } from "../skeleton/Skeleton.styles";

export const HeaderContainer = styled.header`
  width: 100%;
  background-color: #0e0e12;
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #18181b;
  position: fixed;
  z-index: 1000;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  position: relative;
  height: 100%;
  max-width: 1440px;
  width: 100%;
`;

export const Logo = styled.span`
  color: ${(props) => (props.theme === "light" ? "#1a202c" : "#fff")};
  font-size: 2rem;
  font-weight: bold;
`;

export const HeaderRightSide = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.5rem;
`;

export const UpgradeButton = styled.button`
  font-size: 1.6rem;
  font-weight: 500;
  padding: 0.8rem 1.6rem;
  background-color: ${(props) =>
    props.theme === "light" ? "#f1f5f9" : "#181621"};
  color: ${(props) => (props.theme === "light" ? "#1a202c" : "white")};
  outline: none;
  border: none;
  border-radius: calc(2rem - 4px);
  cursor: pointer;

  display: inline-block;
  transition: all 0.2s ease-in-out;

  &:hover {
    animation: shake 0.4s ease-in-out;
  }

  @keyframes shake {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(-3px) rotate(-3deg);
    }
    50% {
      transform: translateX(3px) rotate(3deg);
    }
    75% {
      transform: translateX(-3px) rotate(-3deg);
    }
    100% {
      transform: translateX(0);
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ProUpgradeButtonContainer = styled.div`
  border-radius: 100px;
  border: 1px solid #4d8dff;
  background: #101010;
  box-shadow: 0 -1px 9.5px 0 #005bff inset;
  min-width: 62px;
  padding-inline: 16px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

export const ProUpgradeButtonSkeleton = styled(Skeleton)`
  border-radius: 100px;
  border: 1px solid #4d8dff;
  background: #101010;
  box-shadow: 0 -1px 9.5px 0 #005bff inset;
  height: 36px;
  display: flex;
  display: flex;
  min-width: 62px;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

export const CreditText = styled.span`
  color: #f2efe8;
  font-family: Figtree;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.07px;
`;

export const ProfileSection = styled.div`
  position: relative;
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 5rem;
  right: 0;

  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
  z-index: 1000;
  animation: ${(props) => (props.$animating ? "fadeOut" : "fadeIn")} 0.15s ease;

  display: flex;
  width: 200px;
  padding: 16px 14px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border-radius: 16px;
  border: 1px solid #3f3f46;
  background: #18181b;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(-10px);
    }
  }
`;

export const DropdownItem = styled.div`
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;

  width: 100%;
  color: #fff;
  font-family: Figtree;

  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;

  &:hover {
    transform: translateX(2px);
  }
`;

export const DropdownSeparator = styled.div`
  height: 1px;
  background-color: #3f3f46;
  width: 100%;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;
export const EmailText = styled.div`
  color: #fff;
  font-family: Figtree;

  font-size: 14px;
  opacity: 0.6;
  font-weight: 400;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: 0.07px;
  width: 100%;
`;

export const ThemeIcon = styled(FaMoon)`
  font-size: 1.4rem;
`;

export const PlayIcon = styled(FaCirclePlay)`
  height: 18px;

  width: 18px;
`;
export const PauseIcon = styled(FaCirclePause)`
  height: 18px;

  width: 18px;
`;

export const LogoutIcon = styled(FaSignOutAlt)`
  font-size: 1.4rem;
`;

export const BalanceContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 10px;
`;

export const BalanceValue = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 24px;
  font-weight: 400;
  letter-spacing: -0.12px;
`;

export const BuyNow = styled.span`
  color: #fd5bb3;
  font-family: Figtree;
  text-align: center;
  font-size: 14px;
  align-self: center;
  font-weight: 400;
  letter-spacing: 0.07px;
  text-decoration-line: underline;

  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    transform: translateY(-2px);
  }
`;

export const Text = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  align-self: center;
  text-align: center;
  font-weight: 400;
  margin-top: -11px;
  letter-spacing: -0.07px;
`;
